export default function LinkIcon({ color = "#8897AE" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M7.07214 10.3137L5.0145 12.3713C3.25714 14.1287 3.25714 16.9779 5.0145 18.7353C6.77186 20.4926 9.6211 20.4926 11.3785 18.7353L14.1211 15.9926C15.8785 14.2353 15.8785 11.386 14.1211 9.62866C13.7492 9.25676 13.3284 8.96356 12.8794 8.74906L11.9998 9.62866C11.9083 9.72013 11.8311 9.82047 11.7682 9.92692C12.2414 10.0625 12.6877 10.3166 13.0604 10.6893C14.232 11.8609 14.232 13.7604 13.0604 14.932L10.3178 17.6746C9.14623 18.8462 7.24673 18.8462 6.07516 17.6746C4.90359 16.503 4.90359 14.6035 6.07516 13.432L7.26407 12.2431C7.09578 11.6129 7.0318 10.9606 7.07214 10.3137Z"
        fill={color}
      />
      <path
        d="M9.87846 7.50734C8.1211 9.2647 8.1211 12.1139 9.87846 13.8713C10.2504 14.2432 10.6712 14.5364 11.1202 14.7509L12.2836 13.5875C11.7911 13.456 11.3255 13.197 10.9391 12.8106C9.76755 11.6391 9.76755 9.73958 10.9391 8.568L13.6818 5.82536C14.8533 4.65379 16.7528 4.65379 17.9244 5.82536C19.096 6.99693 19.096 8.89643 17.9244 10.068L16.7355 11.2569C16.9038 11.8871 16.9678 12.5393 16.9274 13.1863L18.9851 11.1287C20.7424 9.3713 20.7424 6.52206 18.9851 4.7647C17.2277 3.00734 14.3785 3.00734 12.6211 4.7647L9.87846 7.50734Z"
        fill={color}
      />
    </svg>
  );
}
